export const isSafeRedirectPath = (url: string | null | undefined): url is string => {
  if (url === null || url === undefined || url.length === 0) return false
  return url.startsWith('/') && !url.startsWith('//')
}
